export const getEntityName = (entityName: string) => {
  return entityName.toLowerCase().trim().replace(/\s+/g, '_');
};
